import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  NgZone,
  OnInit,
  ViewChild
} from '@angular/core';
import {SwiperComponent} from 'swiper/angular';
// import Swiper core and required modules
import SwiperCore, {Navigation, Pagination, SwiperOptions} from 'swiper';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute} from '@angular/router';
import {DomSanitizer} from '@angular/platform-browser';
import {
  ActionSheetController, IonSelect,
  LoadingController,
  ModalController,
  NavController,
  Platform,
  PopoverController,
  ToastController
} from '@ionic/angular';
import {LangService} from 'src/app/services/lang.service';
import {RestService} from 'src/app/services/rest.service';
import {UtilService} from 'src/app/services/util.service';
import {LocationService} from 'src/app/services/location.service';
import {AddDiscComponent} from 'src/app/modal/add-disc/add-disc.component';
import {LocationAutocompleteItemData} from 'src/models/commons/interfaces';
import {Camera, CameraResultType, CameraSource} from '@capacitor/camera';
import {Profile} from 'src/models/commons/profiles';
import {InstrumentsRating} from "../../../models/commons/instrumentsRating";
import {Instruments} from "../../../models/commons/instruments";
import {ExtendedProfile} from "../../../models/commons/extendedProfile";
import {SharedVarModalService} from "../../services/shared-var-modal.service";
import {HomePage} from "../../pages/home/home.page";
import {Location} from "@angular/common";
import {HttpClient} from "@angular/common/http";
import {debounceTime, distinctUntilChanged, map, switchMap} from "rxjs/operators";
import {BehaviorSubject, of} from "rxjs";
import { Renderer2 } from "@angular/core";
import {Share} from "@capacitor/share";
// Pixel library importing
import { PixelService } from 'ngx-pixel';
import {ShareMenu} from "share-menu";
import {SeoProvider} from "../../services/seo";

// install Swiper modules
SwiperCore.use([Navigation, Pagination]);

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.page.html',
  styleUrls: ['./my-profile.page.scss'],
})
export class MyProfilePage implements OnInit, AfterContentChecked { //TODO: posiblemente se pueda solucionar con un ngAfterViewinit lo de recargar el select para desactivar en tiempo real
  loadMostWanted: any;
  @ViewChild('swiper') swiper: SwiperComponent;
  @ViewChild('popover') popover;
  @ViewChild('popoverEditPost') popoverEditPost;
  @ViewChild('popoverEditDiscAlbum') popoverEditDiscAlbum;
  @ViewChild('homePage') homePage: HomePage;
  @ViewChild('miSelect') miSelect: IonSelect;
  config3: SwiperOptions = {
    initialSlide: 1,
    slidesPerView: 3.3,
    spaceBetween: 60,
    navigation: true,
    centeredSlides: true,
    centeredSlidesBounds: true,
    allowSlidePrev: true,
    allowSlideNext: true,
    slideToClickedSlide: true,
  };
  isOpen = false;
  isOpenPost = false;
  isOpenEditDisc = false;
  isMobile: boolean;
  isMobileSlide: boolean = false;
  listShare: boolean = false;
  langH: any;
  id: string;
  searchTop: any;
  showOverSearch: boolean;
  helpFocus: boolean;
  profile: any;
  dataDynamic: any[] = [];
  dataSlider: any[] = [];
  dataSearchSlider: any[] = [];
  maxAlbum = 4;
  seeAllAlbumbs: boolean;
  load: boolean;
  slidesCourse5F: SwiperOptions = {
    initialSlide: 1,
    slidesPerView: 1.7,
    spaceBetween: 16,
    navigation: true,
    centeredSlides: false,
    centeredSlidesBounds: false,
    allowSlidePrev: true,
    allowSlideNext: true,
    slideToClickedSlide: true
  };
  isAlbumsBigger: boolean;
  user: any;
  profileUpdate: any;
  profiles: any;
  genres: string[];
  profilesByname: string[];

  skills: ExtendedProfile[] = [];
  socials: ExtendedProfile[] = [];
  profileSocials: ExtendedProfile[] = [];
  editSocials: ExtendedProfile[] = [];
  profileSkills: ExtendedProfile[] = [];
  profileGenres: ExtendedProfile = {
    values: [], label: '', user_field_id: null
  };
  profileCheckbox: ExtendedProfile = {
    values: [], label: '', user_field_id: null
  };
  profileProfiles: ExtendedProfile = {
    values: [], label: '', user_field_id: null
  };
  profileEvents: ExtendedProfile = {
    values: [], label: '', user_field_id: null
  };
  profileInstruments: ExtendedProfile = {
    values: [], label: '', user_field_id: null
  };
  profilePrize: ExtendedProfile = {
    values: [], label: '', user_field_id: null
  };
  profilePrizeImg : string;
  widthList: number;
  edit: boolean = true;
  location: string;
  locationsAutocomplete: any[] = [];
  selectedProfiles: any[] = [];
  selectedGenres: string[] = [];
  selectedProfile: any = [];
  selectedProfileString: any = [];
  selectedEvents: any = [];
  selectedEventsString: any = [];
  selectedCheckBox: any[] = [];
  selectedCheckBoxOrigin: any[] = [];
  selectedPrize: string[] = [];
  selectedSkills: ExtendedProfile[] = [];
  selectedLocation: {
    place_id: string;
    latitude: any;
    longitude: any;
    country: string;
    administrative_area_level_1: string;
    administrative_area_level_2: string;
    locality: string;
  };
  helpPro: boolean;
  helpBio: boolean = false;
  helpBioNotEdit: boolean = false;
  selectedProfileType: string;
  selectedGenreName: string;
  selectedSkillName: string;
  showCam: boolean;
  activated: any[];
  instruments: any[];
  isSearching: boolean = false;
  isMacOS: boolean = false;
  isIOS: boolean = false;

  //aqui

  helpUbication: boolean = false;
  helpSocial: boolean = false;
  helpAlbum: boolean = false;
  helpInstruments: boolean = false;
  helpSkills: boolean = false;
  helpGenre: boolean = false;
  helpCheckBox: boolean =false;
  helpProfiles: boolean =false;
  helpProfilesEdit: boolean =false;
  helpEditAll: boolean = false;
  sectionEdit: string = null;
  helpEditNameProfile: boolean = false;
  helpRecognition: boolean = false;
  helpEvents: boolean = false;
  helpEventsEdit: boolean = false;
  helpPrize: boolean = false;
  prizeName: string;
  prizeCategory: string;
  availableInstruments: string[] = [];
  nameInstruments: Instruments;
  ratingInstruments: number = 0;
  listGrid: any[] = [];
  multimedia: any;
  disabledEdit: boolean = false;
  selectedInstruments: InstrumentsRating[] = [];
  modalShowRegisterTelco: boolean;
  modalShowAlertDelete: boolean;
  modalShowAlertDeleteDisc: boolean;
  dataPost: any;
  dataEditDisc: any;
  idOptionSearch: string;
  selectedInstrumentDisc: any[] = [];
  selectedArtDisc: any[] = [];
  selectedRecordingDisc: any[] = [];
  selectedMasteringDisc: any[] = [];
  musician: boolean = false;
  producer: boolean = false;
  art: boolean = false;
  recording: boolean = false;
  mastering: boolean = false;
  disableOption: boolean = false;
  optionSelectedDiscArt: any[] = [];
  optionSelectedDiscRecording: any[] = [];
  optionSelectedDiscMastering: any[] = [];
  optionSelectedDiscInstrument: any[] = [];
  optionSelectedDiscProducer: string = null;
  artList = [{label: 'Diseño', value: 'Diseño'}, {label: 'Fotografía', value: 'Fotografía'}];
  recordingList = [{label: 'Ingeniero de grabación', value: 'Ingeniero de grabación', disabled: false, type: 'persona'}, {
    label: 'Asistente de grabación',
    value: 'Asistente de grabación', disabled: false, type: 'persona'},
    {label: 'Edición', value: 'edicion', disabled: false, type: 'persona'},
    {label: 'Estudio de grabación', value: 'Estudio de grabación', disabled: false, type: 'estudio'}];
  masteringList = [{label: 'Ingeniero de mezcla', value: 'Ingeniero de mezcla', disabled: false, type: 'persona'}, {
    label: 'Asistente de mezcla',
    value: 'Asistente de mezcla', disabled: false, type: 'persona'
  }, {label: 'Edición', value: 'Edición', disabled: false, type: 'persona'}, {
    label: 'Ingeniero de mastering',
    value: 'Ingeniero de mastering', disabled: false, type: 'persona'
  }, {label: 'Asistente de mastering', value: 'Asistente de mastering', disabled: false, type: 'persona'}, {
    label: 'Estudio de mezcla',
    value: 'Estudio de mezcla', disabled: false, type: 'estudio'
  }, {label: 'Estudio de mastering', value: 'Estudio de mastering', disabled: false, type: 'estudio'}];
  searchDiscSpotify = new BehaviorSubject<string>('');
  infoSearchSpotify: any[];
  selectedDiscSpotifyImg: string;
  selectedDiscSpotifyArtist: string;
  selectedDiscSpotifyName: string;
  showSelectedDiscSpotify: boolean;
  private selectedDiscSpotifyReleaseDate: string;
  private selectedDiscSpotifyExternalUrl: string;
  private selectedIdSpotify: string;
  private selectedItemJob: any[] = [];
  showModalPublishDisc: boolean = false;
  seeAllAlbumsEdit: boolean;
  showDiscEdit: boolean;
  showButtonEditDisc: boolean;

  constructor(
    public sharedVarModalService: SharedVarModalService,
    public rest: RestService,
    public navCtrl: NavController,
    public actionSheetCtrl: ActionSheetController,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public util: UtilService,
    public platform: Platform,
    public domSanitizer: DomSanitizer,
    public zone: NgZone,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    public locationService: LocationService,
    public langService: LangService,
    public elementRef: ElementRef,
    private toastController: ToastController,
    private popoverController: PopoverController,
    private locationRouter: Location,
    private http: HttpClient,
    private renderer: Renderer2,
    private pixel: PixelService,
    public toastCtrl: ToastController,
    public seoService: SeoProvider,
  ) {
    if (this.platform.is('android') || this.platform.is('ios')) {
      this.isMobile = true;
    }
    this.langService.getLanguajeStorage().then((val => {
      if (val) {

        console.log('>>>XXX1-home', val);
        this.reloadTrans(val);
      } else {
        console.log('>>>XXX3');
        this.reloadTrans('es');
      }
    })).catch((err) => {
      console.log('>>>XXX5');
      this.reloadTrans('es');
    });


    this.profileUpdate = {
      profiles: [],
    };

    this.isMacOS = (navigator.userAgent.indexOf('Macintosh') > 0 && navigator.userAgent.indexOf('Safari') > 0 && navigator.userAgent.indexOf('Chrome') <= 0) ? true : false;
    this.isIOS = (navigator.userAgent.indexOf('iPhone') > 0) ? true : false;

  }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
    //console.log('id', this.id);

    setTimeout(() => {
      this.rest.getStorage('user').then((val) => {
        this.user = val;
        //console.log(val);
        if (!val) {
          this.navCtrl.navigateRoot('login');
        } else {
          this.loadDataProfile();
        }
      });

    }, 500);

    this.searchDiscSpotify.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((term: string) => this.getDiscSpotify(term)),
      map((response: any) => response.body.data?.discs),
    ).subscribe(discs => {
      this.infoSearchSpotify = discs;
    });
    // https://v2.louderband.com/api/accounts/user-information/7275?
  }


  private reloadTrans(lang) {
    this.translate.use(lang);
    this.langService.setTranslateLanguage(lang);
    this.langH = lang;
  }

  ionViewDidEnter() {
    this.id = this.route.snapshot.paramMap.get('id');
    //console.log('id', this.id);

    setTimeout(() => {
      this.rest.getStorage('user').then((val) => {
        this.user = val;
        //console.log(val);
        if (!val) {
          this.navCtrl.navigateRoot('login');
        } else {
          this.loadDataProfile();
        }
      });

    }, 500);
  }

  gotoCourses() {
    this.navCtrl.navigateForward('/cursos');
  }

  outData2(ev) {

    if (ev && ev.blur) {
      this.showOverSearch = false;
      this.searchTop = null;
      this.helpFocus = false;
    }
  }

  async getProfileInfo() {
    const auxLoading = await this.loadingCtrl.create({});
    await auxLoading.present();

    this.rest._get('accounts/basic-data').subscribe(resx => {
      const res: any = resx.body;
      this.profile = res;
      if (this.profile && this.profile.bio && this.profile.bio.trim() === '.') {
        this.profile.bio = '';
      }
      this.getSliderProfile();
      this.getSearchSliderProfile();
      let params = {
        id: this.profile.user_id
      }
      this.rest._get('discs/user/' + this.profile.user_id).subscribe(async (resx2) => {
        const res2: any = resx2.body;
        let auxRes: any = res2;
        auxRes = auxRes.data.discs;
        auxRes = auxRes.sort((a, b) => new Date(b.release_date).getTime() - new Date(a.release_date).getTime());
        this.profile.albums = auxRes;
        let auxAlbum = [];
        for (let index = 0; index < this.profile.albums.length; index++) {
          if (index < 9) {
            auxAlbum.push(this.profile.albums[index]);
          }
        }
        this.profile.albumsSort = auxAlbum;
        if (this.profile.albums.length > 6) {
          this.isAlbumsBigger = true;
        } else {
          this.isAlbumsBigger = false;
        }
        await auxLoading.dismiss();
      }, async (res) => {
        await auxLoading.dismiss();
        //console.log(res);
      });
      const user = this.user;
      user.profile_image = res.profile_image;
      user.profile_cover = res.profile_cover;
      this.rest.storageSet('user', user);
      if (this.profile.profiles && this.profile.profiles.length > 0) {
        for (const profile of this.profile.profiles) {
          this.profileUpdate.profiles.push(profile.name);
        }
      }

      this.loadProfileEditLink();
      this.getExtendedProfile();
    }, async (rees) => {
      await auxLoading.dismiss();
     //console.log('error loading data', rees);
    });
  }

  loadProfileEditLink() {
    /*his.parametersService.getById(2).then(res => {
      this.profile.edit_more = res.value;
    }).catch(res => {
      console.log('cant load edit link');
    });*/
  }


  profilesList() {
    this.rest._get('profiles?per-page=50').subscribe(resv => {
      const res: any = resv.body;
      this.profiles = res.items;

      setTimeout(() => {
        if (document.getElementById('listP')) {
          //console.log(document.getElementById('listP').offsetWidth);
          this.widthList = document.getElementById('listP').offsetWidth;
          if (this.platform.is('android') || this.platform.is('ios')) {
            this.widthList = this.widthList / 3;
          } else {
            this.widthList = 500 / 3;
          }

        }
      }, 1000);
    }, (resxc) => {
      console.log('error loading profiles', resxc)
    });
  }

  outData(ev) {
    if (ev && ev.editProfile) {
      this.navCtrl.navigateForward('mi-perfil');
    }

    if (ev && ev.focus) {
      this.showOverSearch = true;
      if (ev.search === '') {
        this.searchTop = '';
      }
      setTimeout(() => {
        this.helpFocus = true;
      }, 1800);
    }

    if (ev && ev.login) {
      // this.openLogin();
      this.navCtrl.navigateRoot('/login');
    }

    if (ev && ev.home) {
      let url = '/home';
      this.locationRouter.go(url);
    }
    if (ev && ev.referred) {
      let url = '/referred';
      this.navCtrl.navigateRoot(url);
    }

    if (ev && ev.old) {
      // this.navCtrl.navigateRoot('/registro')
      this.gotoOldApp(ev.view);
    }


    if (ev && ev.search) {
      //console.log(ev.search);
      this.searchTop = ev.search;

    }

    if (ev && typeof ev.isMobile === 'boolean') {
      // console.log(ev);
      this.isMobile = ev.isMobile;
    }

  }

  gotoOldApp(view?) {
    //console.log(view);

    if (view) {
      this.navCtrl.navigateForward(view);
    } else {
      window.open('https://louderband.com/', '_self');
    }
  }

  ngAfterContentChecked() {
    if (this.swiper) {
      this.swiper.updateSwiper({})
    }

    this.cdRef.detectChanges();
  }

  async loadDataProfile() {
    const auxLoading = await this.loadingCtrl.create({});
    await auxLoading.present();
    this.rest._get('accounts/user-information/' + this.user.user_id, 'get').subscribe(response => {
      setTimeout(() => {
        auxLoading.dismiss();
      }, 1000);
      this.getProfiles();
      this.getGenres();
      this.getInstruments();

      const res: any = response.body;
      console.log('profile');
      console.log(res);
      this.profile = res;
      if (this.profile && this.profile.bio && this.profile.bio.trim() === '.') {
        this.profile.bio = '';
      }
      this.metaDatos();
      //Termina Prueba Gender
      this.selectedProfiles = [...this.profile.profiles];
      this.getExtendedProfile();
      this.getSliderProfile();
      this.getSearchSliderProfile();
      this.rest._get('discs/user/' + this.profile.user_id, 'get').subscribe(res2 => {
        const resxx: any = res2.body;
        //console.log(resxx);
        let auxRes: any = resxx;
        auxRes = auxRes.data.discs;
        auxRes = auxRes.sort((a, b) => new Date(b.release_date).getTime() - new Date(a.release_date).getTime());
        this.profile.albums = auxRes;
        setTimeout(() => {
          this.load = true;
        }, 200);
      }, (errv) => {
        //this.loading.dismiss();
        console.error(errv);
        setTimeout(() => {
          this.load = true;
        }, 200);
      });
    }, (err) => {
      if (auxLoading) {
        auxLoading.dismiss();
      }
      console.error('There was an error loading this data', err);
    });
  }

  getSliderProfile() {

    const observable = this.rest._get('profile/content/' + this.profile.id, 'get');
    observable
      .subscribe(response => {
        const res: any = response.body;
        this.getDataProfile();
        //console.log(res);
        this.dataSlider = res.content;

      }, (resr) => {
        console.log(resr);
      });
    return observable;
  }

  getSearchSliderProfile() {
    const observable = this.rest._get('profile/searches/' + this.profile.id);
    observable
      .subscribe(response => {
        const res: any = response.body;
        this.dataSearchSlider = res.content;

      }, (resr) => {
        console.log(resr);
      });
    return observable;
  }

  getDataProfile() {
    let profiles: any[] = [];
    let dataP = '';
    if (this.profile.profiles) {
      //console.log(this.profile.profiles);
      for (const iterator of this.profile.profiles) {
        profiles.push(iterator.name);
      }
      dataP = profiles.toString();
      dataP = dataP.replace(/,/g, '.');
    }
    if (!profiles) {
      return;
    }
    this.rest._get('profile/fields/' + dataP + '/' + this.profile.user_id, 'get')
      .subscribe(response => {
        const res: any = response.body;
        //console.log(res);
        this.dataDynamic = res.fields;
        let aux: boolean;
        try {
          for (let ita of this.dataDynamic) {
            let typeAux = true;
            for (let iterator of ita.fields) {
              aux = false;
              //console.log(iterator);
              if (typeof iterator.values === "boolean") {
                typeAux = false;
              }
              if (typeAux && iterator.values && iterator.values.indexOf('[') >= 0) {
                aux = true;
              }
              if (aux && iterator.values && iterator.values.length > 0) {
                //console.log(iterator.values);
                iterator.values = JSON.parse(iterator.values);
              }
            }
            if (!typeAux) {
              ita.fields = ita.fields.sort((a1, b1) => b1.values - a1.values);
            }
            if (ita.type == 'social') {
              //console.log(ita);
              ita.fields = ita.fields.sort((b, a) => a.values.localeCompare(b.values));
            }
          }
        } catch (error) {
          console.error(error);
        }

        //console.log(this.dataDynamic);
      }, (resr) => {
        //this.loading.dismiss();
        console.log(resr);
      });
  }

  getLocation(country, administrative_area_level_1, administrative_area_level_2) {
    return this.locationService.getLocationName({
      administrative_area_level_1: administrative_area_level_1,
      administrative_area_level_2: administrative_area_level_2,
      country: country,
    });
  }

  gotoAllDisc() {
    /*let tabPadre: Tabs = this.navCtrl.parent;
    tabPadre.parent.push(AllDiscPage, { profile: this.profile, discs: this.profile.albums, widthList: this.widthList });
  */
  }

  getAlbumExtraInformation(album) {
    let information = '';
    let artists = JSON.parse(album.artists);
    if (artists && artists.length) {
      information += artists.join(',');
    }

    information += ' (' + (new Date(album.release_date)).getFullYear() + ')';
    return information;
  }

  goToDetails(item) {
    switch (item.type) {
      case 'course':
        this.navCtrl.navigateForward('cursos/' + item.id);
        break;
      case 'lesson':
        this.navCtrl.navigateForward('servicios/' + item.type + '/' + item.id);
        break;
      case 'sound-market':
        this.navCtrl.navigateForward('servicios/sound/' + item.id);
        break;
      default:
        break;
    }
  }

  goToDetailsServices(item) {
    this.navCtrl.navigateForward('busquedas-publicadas/' + item.subtype + '/' + item.id);
  }

  goToNewServices() {
    this.navCtrl.navigateForward('/home?proposal=true');
  }

  onSwiper(ev) {

  }

  onSlideChange() {
  }


  goToDisc(val, owner) {
    //this.navCtrl.navigateForward('disc/' + val.id + '/' + owner.id);
    this.navCtrl.navigateForward('creditos/' + val.id);
  }

  async gotoAddDisc() {

    const modal = await this.modalCtrl.create({
      component: AddDiscComponent,
      componentProps: {user: this.profile, dataDisc: null}
    });
    await modal.present();

    const {data} = await modal.onWillDismiss();
  }

  fetchLocations() {
    if (this.location == '') {
      this.locationsAutocomplete = [];
      this.selectedLocation = {
        place_id: '',
        latitude: undefined,
        longitude: undefined,
        country: '',
        administrative_area_level_1: '',
        administrative_area_level_2: '',
        locality: '',
      };
      return;
    }

    this.locationService.fetchLocations(this.location).then(
      (predictions: Array<LocationAutocompleteItemData>) => {
        console.info(predictions);
        this.locationsAutocomplete = [];

        if (predictions) {
          this.zone.run(() => {
            predictions.forEach((prediction) => {
              this.locationsAutocomplete.push(prediction);
            });
          });
        }
      }
    );
  }

  getCurrentLocation(doSearch?: boolean) {
    this.locationService.getCurrentLocation().then((currentLocation) => {
      this.selectedLocation = {
        place_id: currentLocation.place_id,
        latitude: currentLocation.latitude,
        longitude: currentLocation.longitude,
        country: currentLocation.country,
        administrative_area_level_1: currentLocation.administrative_area_level_1,
        administrative_area_level_2: currentLocation.administrative_area_level_2,
        locality: currentLocation.locality,
      };

      this.location = currentLocation.location;
    }).catch((err) => {
      console.error(err);
    });
  }


  public selectLocation(item: LocationAutocompleteItemData) {
    this.location = item.description;
    this.locationsAutocomplete = [];

    this.locationService.selectLocation(item.place_id).then((location) => {
      this.selectedLocation = location;
    }).catch((err) => console.error(err));
  }

  cancel1() {
    this.edit = false;
  }

  save() {
    // this.edit = false;
    console.log('save... ')
  }

  showProfessional() {
    if (this.edit) {
      this.scrolltoTop();
      this.helpPro = !this.helpPro;
      this.sectionEdit = this.helpPro ? 'professional' : null;
      this.disabledEdit = !this.disabledEdit;
    }
  }

  showBio() {
    if (this.edit) {
      this.helpBio = !this.helpBio;
      this.sectionEdit = this.helpBio ? 'album' : null;
      this.disabledEdit = !this.disabledEdit;
    }
  }

  showBioNotEdit() {
    if (this.edit) {
      this.scrolltoTop();
      this.helpBioNotEdit = !this.helpBioNotEdit;
    }
  }

  public getProfileClasses(profile: Profile) {
    let classes = {'activated': false, 'deactivated': false, 'disabled': false};
    const fprofile = this.selectedProfiles.filter(x => x.name === profile.name)[0];

    if (this.selectedProfileType && this.selectedProfileType !== profile.type) {
      classes['disabled'] = true;
    }

    if (!classes['disabled']) {
      if (fprofile) {
        classes['activated'] = true;
        classes['deactivated'] = false;
      } else {
        classes['activated'] = false;
        classes['deactivated'] = true;
      }
    }

    return classes;
  }


  public toggleProfile(profile: Profile) {
    const fprofile = this.selectedProfiles.filter((x) => x.name === profile.name)[0];

    if (!fprofile) {
      if (!this.selectedProfileType) {
        this.selectedProfileType = profile.type;
      }

      if (this.selectedProfileType === profile.type) {
        this.selectedProfiles.push(profile);
      }

    } else {
      this.selectedProfiles.splice(this.selectedProfiles.indexOf(fprofile), 1);

      if (this.selectedProfiles.length <= 0) {
        this.selectedProfileType = undefined;
      }
    }
  }

  getProfiles() {
    return this.rest._get('profiles?per-page=0', 's').subscribe((resespone: any) => {
      const res: any = resespone.body;
      this.profiles = res.items;
      return res.items;
    }, (error) => {
      console.error('error: ', error);
      // this.loadingModal(error.message);
    });
  }

  public getGenresClasses(genre: string) {
    let classes = {'activated': false, 'deactivated': false, 'disabled': false};
    const fgenre = this.selectedGenres.filter(g => g === genre)[0];

    if (this.selectedGenreName && this.selectedGenreName !== genre) {
      classes['disabled'] = true;
    }

    if (!classes['disabled']) {
      if (fgenre) {
        classes['activated'] = true;
        classes['deactivated'] = false;
      } else {
        classes['activated'] = false;
        classes['deactivated'] = true;
      }
    }

    return classes;
  }

  public toggleGenre(genre: string) {

    const fgenre = this.selectedGenres.filter((x) => x === genre)[0];

    if (!fgenre) {
      this.selectedGenres.push(genre);
    } else {
      this.selectedGenres.splice(this.selectedGenres.indexOf(fgenre), 1);
    }
  }

  getGenres() {
    return this.rest._get('fields/values/genres').subscribe((resespone: any) => {
      this.genres = resespone.body.values.map(genre => genre.label);
      return this.genres;
    }, (error) => {
      console.error('error: ', error);
    });
  }

  getProfilesByName(name: any){
    return this.rest._get('fields/values/profiles/' + name).subscribe((resespone: any) => {
      this.profilesByname = resespone.body.values.map(profile => profile.label);
      return this.profilesByname;
    }, (error) => {
      console.error('error: ', error);
    });

  }

  public getSkillsClasses(skill: ExtendedProfile) {
    let classes = {'activated': false, 'deactivated': false, 'disabled': false};
    const fskill = this.selectedSkills.filter(x => x.label === skill.label && x.values)[0];

    if (this.selectedSkillName && this.selectedSkillName !== skill.label) {
      classes['disabled'] = true;
    }

    if (!classes['disabled']) {
      if (fskill) {
        classes['activated'] = true;
        classes['deactivated'] = false;
      } else {
        classes['activated'] = false;
        classes['deactivated'] = true;
      }
    }

    return classes;
  }

  public toggleSkill(skill: ExtendedProfile) {

    const fskill = this.selectedSkills.filter((x) => x.label === skill.label)[0];

    if (!fskill) {
      this.selectedSkills.push(Object.assign({}, skill, {values: true}));
    } else {
      fskill.values = false;
    }
  }

  // Cargar Skill y mostrar Skill
  getExtendedProfile() {
    let requestProfile = '';
    for (let i = 0; i < this.profile.profiles.length; i++) {
      requestProfile = requestProfile + this.profile.profiles[i].name;
      if ((this.profile.profiles.length - 1) !== i) {
        requestProfile = requestProfile + '.';
      }
    }

    //this.profile.profiles
    this.rest._get('profile/fields/' + requestProfile + '/' + this.profile.user_id).subscribe((response: any) => {
      // this.getProfileSkill(response.body);
      this.getProfileCheckBox(response.body);
      this.getProfileSocial(response.body);
      this.getProfileGenre(response.body);
      this.getProfilProfiles(response.body);
      this.getProfielEvents(response.body);
      this.getProfileInstruments(response.body);
      this.getProfilePrize(response.body);
    }, (error) => {
      console.error('error: ', error);
    });
  }

  private getProfileSkill(extendedProfile: any) {
    this.skills = [];
    this.profileSkills = [];
    let skills = extendedProfile.fields.filter(sk => sk.type === 'group' && sk.view === 'details'
      && sk.fields && sk.fields.length > 0 && sk.fields[0].group
      && sk.fields[0].group.toLowerCase().trim().startsWith('checkbox '));
    skills = skills.map(sk1 => sk1.fields).reduce((sk1, sk2) => sk1.concat(sk2));
    for (const skill of skills) {
      const sk: ExtendedProfile = {label: skill.label, user_field_id: skill.user_field_id, values: skill.values};
      this.skills.push(sk);
      if (skill.values) {
        this.profileSkills.push(sk);
      }
    }
  }
  //Obtenemos todos los field que sean de tipo checkbox para luego seleccionar el que desearemos manipular
  private getProfileCheckBox(extendedProfile: any) {
    let checkboxProfile: any = extendedProfile.fields.filter(g => (g.fields && g.fields.length > 0 && g.fields[0].component === 'check_field'));
    if (checkboxProfile) {
      let checkboxValue = checkboxProfile;
      try {
        checkboxValue = JSON.parse(checkboxValue);
      } catch (e) {
        checkboxValue = [];
      }
      this.profileCheckbox = {
        user_field_id: checkboxProfile.user_field_id,
        values: checkboxProfile,
        label: checkboxProfile.label
      };
    }
  }

  //Obtenemos todos los field que sean de tipo profiles para luego seleccionar el que desearemos manipular
  private getProfilProfiles(extendedProfile: any) {
    let profileProfiles: any = extendedProfile.fields.filter(g => (g.fields && g.fields.length > 0 && g.fields[0].model === 'profiles'));
    if (profileProfiles) {
      let profileValue = profileProfiles;
      try {
        profileValue = JSON.parse(profileValue);
      } catch (e) {
        profileValue = [];
      }
      this.profileProfiles = {
        user_field_id: profileProfiles.user_field_id,
        values: profileProfiles,
        label: profileProfiles.label
      };
    }
  }


  //Obtenemos todos los field que sean de tipo text para luego seleccionar el que desearemos manipular
  private getProfielEvents(extendedProfile: any) {
    let profileEvents: any = extendedProfile.fields.filter(g => (g.fields && g.fields.length > 0 && g.fields[0].component === 'text_field'));
    if (profileEvents) {
      let eventsValue = profileEvents;
      try {
        eventsValue = JSON.parse(eventsValue);
      } catch (e) {
        eventsValue = [];
      }
      this.profileEvents = {
        user_field_id: profileEvents.user_field_id,
        values: profileEvents,
        label: profileEvents.label
      };
    }
  }



  private getProfileGenre(extendedProfile: any) {
    let genresProfile: any = extendedProfile.fields.find(g => (g.fields && g.fields.length > 0 && g.fields[0].label === 'Géneros'));
    if (genresProfile) {
      genresProfile = genresProfile.fields[0];
      let genresValue;
      try {
        genresValue = JSON.parse(genresProfile.values);
      } catch (e) {
        genresValue = [];
      }
      this.profileGenres = {
        user_field_id: genresProfile.user_field_id,
        values: genresValue,
        label: genresProfile.label
      };
    }
  }

  private getProfileInstruments(extendedProfile: any) {
    let instrumentsProfile = extendedProfile.fields.find(g => (g.fields && g.fields.length > 0 && g.fields[0].label === 'Instrumentos'));
    if (instrumentsProfile) {
      instrumentsProfile = instrumentsProfile.fields[0];
      let instrumentsList;
      try {
        const parsedInstrumentList = JSON.parse(instrumentsProfile.values);
        instrumentsList = parsedInstrumentList.map((i) => {
          if (typeof i === 'string') {
            return ({instrument: i, level: 0});
          }
          return ({instrument: i.instrument, level: i.level});
        });
      } catch (e) {
        instrumentsList = [];
      }
      this.profileInstruments = {
        user_field_id: instrumentsProfile.user_field_id,
        values: instrumentsList,
        label: instrumentsProfile.label
      };
    }
  }

  private getProfilePrize(extendedProfile: any) {
    let prizeProfile = extendedProfile.fields.find(g => (g.fields && g.fields.length > 0 && g.fields[0].label === 'Premios'));
    if (prizeProfile) {
      prizeProfile = prizeProfile.fields[0];
      this.profilePrizeImg = prizeProfile.image;
      let prizeValues;
      try {
        prizeValues = JSON.parse(prizeProfile.values);
      } catch (e) {
        prizeValues = [];
      }
      this.profilePrize = {
        user_field_id: prizeProfile.user_field_id,
        values: prizeValues,
        label: prizeProfile.label
      };
    }
  }

  private getProfileSocial(extendedProfile: any) {
    this.socials = [];
    this.profileSocials = [];
    let socials: any = extendedProfile.fields.find(sc => (sc.type && sc.type === 'social'));
    socials = socials ? socials.fields : [];
    for (const social of socials) {
      const scial: ExtendedProfile = {
        label: social.label,
        user_field_id: social.user_field_id,
        values: social.values && social.values === '.' ? null : social.values,
        image: social.image
      };
      this.socials.push(scial);
      if (scial.values) {
        this.profileSocials.push(scial);
      }
    }
  }

  buildUrlSocial(social: any) {
    if(social.label === 'Instagram'){
      const baseUrl = 'https://www.instagram.com/';
      const encodedNickname = encodeURIComponent(social.values);
      window.open(baseUrl + encodedNickname, '_blank');
    }
    if(social.label === 'TikTok'){
      const baseUrl = 'https://www.Tiktok.com/@';
      const encodedNickname = encodeURIComponent(social.values);
      window.open(baseUrl + encodedNickname, '_blank');
    }
    if(social.label === 'YouTube'){
      const baseUrl = 'https://www.youtube.com/@';
      const encodedNickname = encodeURIComponent(social.values);
      window.open(baseUrl + encodedNickname, '_blank');
    }
    if(social.label === 'Twitter'){
      const baseUrl = 'https://www.twitter.com/';
      const encodedNickname = encodeURIComponent(social.values);
      window.open(baseUrl + encodedNickname, '_blank');
    }
    if(social.label === 'Facebook'){
      const baseUrl = 'https://www.Facebook.com/';
      const encodedNickname = encodeURIComponent(social.values);
      window.open(baseUrl + encodedNickname, '_blank');
    }
    if(social.label === 'Spotify'){
      window.open(social.values, '_blank');
    }
  }

  getInstruments() {
    return this.rest._get('fields/values/instruments').subscribe((resespone: any) => {
      this.availableInstruments = resespone.body.values.map(instrument => instrument.label);
      return this.availableInstruments;
    }, (error) => {
      console.error('error: ', error);
    });
  }

  updateProfiles() {
    this.showCam = true;
    this.profileUpdate.profiles = this.selectedProfiles;
    this.updateSkills();
    this.updateSocial();
    this.updateGenres();
    this.updatecheckbox();
    this.updatePrize();
    this.updateInstruments();
    this.updateProfileInfo();
    this.updateProfilesEdit();
    this.updateEventsEdit();
    this.sectionEdit = null;
    this.disabledEdit = false;
  }

  processProfileUpdate() {
    this.profileUpdate.profiles = this.selectedProfiles;
    this.profileUpdate.name = this.profile.name;
    const instruments = [];
    this.profile.instruments.forEach((v, i) => {
      instruments.push(v.instrument_id);
    });
    this.profileUpdate.instruments = instruments;
    this.profileUpdate.bio = !this.profile.bio || this.profile.bio.trim() === '' ? '.' : this.profile.bio;
    this.profileUpdate.profile_image = this.profile.profile_image;
    this.profileUpdate.profile_cover = this.profile.profile_cover;
    this.profileUpdate.profile_ubication = this.profile.profile_ubication;
  }

  async updateProfileInfo() {
    this.activated = [];
    this.processProfileUpdate();
    let profiles = (this.profileUpdate.profiles.filter((v, i, a) => a.indexOf(v) === i)).map((p) => p.name);
    this.profileUpdate.profiles = profiles;

    const auxLoading = await this.loadingCtrl.create({});
    await auxLoading.present();


    if (this.selectedLocation && (this.selectedLocation.country || this.selectedLocation.administrative_area_level_1)) {
      this.profileUpdate.country = this.selectedLocation.country;
      this.profileUpdate.administrative_area_level_1 = this.selectedLocation.administrative_area_level_1;
    }

    this.rest._post('accounts/update', this.profileUpdate).subscribe(async (resx) => {
      const res: any = resx.body;
      this.getProfileInfo();
      this.helpPro = false;
      this.helpBio = false;
      this.helpUbication = false;
      this.helpSocial = false;
      this.helpInstruments = false;
      this.helpSkills = false;
      this.helpGenre = false;
      this.helpCheckBox = false;
      this.helpProfiles = false;
      this.helpProfilesEdit = false;
      this.helpRecognition = false;
      setTimeout(() => {
          window.location.reload();
        }, 2000);
      await auxLoading.dismiss();
    }, async (err) => {
      console.log(err);
      alert('Hubo un inconveniente. Intenta de nuevo más tarde.');
      this.getProfileInfo();
      await auxLoading.dismiss();
    });
  }

  public async getImageSheet() {
    var actionButtons = [
      {
        text: this.isIOS ? 'Galería o Cámara' : 'Galería',
        role: null,
        icon: 'images',
        handler: () => {
          this.takePick1();
        }
      },
    ];

    if (!this.isIOS) {
      actionButtons.push({
        text: 'Cámara',
        role: null,
        icon: 'camera',
        handler: () => {
          this.takePick2();
        }
      });
    }

    actionButtons.push({
      text: 'Cancelar',
      role: 'cancel',
      icon: 'close',
      handler: () => {
      }
    });

    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Agregar fotos',
      cssClass: 'action-sheet',
      mode: 'md',
      buttons: actionButtons
    });
    actionSheet.present();

  }


  async takePick1() {
    const imageGalery = await Camera.getPhoto({
      quality: 80,
      allowEditing: false,
      resultType: CameraResultType.Base64,
      width: 600,
      height: 600,
      source: CameraSource.Photos,
      correctOrientation: true
    });
    let imageUrl = imageGalery.base64String;

    this.profile.profile_image = 'data:image/png;base64,' + imageUrl;

    if (imageUrl) {
      this.updateProfileInfo();
    }

  }


  async takePick2() {

    const imageCamera = await Camera.getPhoto({
      quality: 80,
      allowEditing: true,
      resultType: CameraResultType.Base64,
      width: 600,
      height: 600,
      source: CameraSource.Camera,
      correctOrientation: true
    });
    let imageUrl = imageCamera.base64String;
    this.profile.profile_image = 'data:image/png;base64,' + imageUrl;

    if (imageUrl) {
      this.updateProfileInfo();
    }
  }

  editNameProfile() {
    if (this.edit) {
      this.helpEditNameProfile = !this.helpEditNameProfile;
      this.sectionEdit = this.helpEditNameProfile ? 'profileName' : null;
      this.disabledEdit = !this.disabledEdit;
    }
  }

  showUbication() {
    if (this.edit) {
      this.scrolltoTop();
      this.helpUbication = !this.helpUbication;
      this.sectionEdit = this.helpUbication ? 'ubication' : null;
      this.disabledEdit = !this.disabledEdit;
    }
  }

  showAlbum() {
    if (this.edit) {
      this.scrolltoTop();
      this.helpAlbum = true;
      this.sectionEdit = this.helpAlbum ? 'album' : null;
      this.disabledEdit = true;
      this.clearAllDisc();
      this.seeAllAlbumsEdit = false;
    }
  }

  closeShowAlbum() {
    if (this.edit) {
      this.scrolltoTop();
      this.helpAlbum = false;
      this.sectionEdit = this.helpAlbum ? 'album' : null;
      this.disabledEdit = false;
      this.clearAllDisc();
      this.seeAllAlbumsEdit = false;
    }
  }

  showDiscEditAlbums() {
    if (this.edit) {
      this.scrolltoTop();
      this.helpAlbum = true;
      this.sectionEdit = this.helpAlbum ? 'album' : null;
      this.disabledEdit = true;
      this.seeAllAlbumsEdit = false;
    }
  }

  showEditAlbums() {
    if (this.edit) {
      this.scrolltoTop();
      this.seeAllAlbumsEdit = !this.seeAllAlbumsEdit;
      this.sectionEdit = this.seeAllAlbumsEdit ? 'albumEdit' : null;
      this.disabledEdit = true;
    }
  }

  closeShowEditAlbums() {
    if (this.edit) {
      this.scrolltoTop();
      this.seeAllAlbumsEdit = !this.seeAllAlbumsEdit;
      this.sectionEdit = this.seeAllAlbumsEdit ? 'albumEdit' : null;
      this.disabledEdit = false;
    }
  }

  showSocial() {
    if (this.edit) {
      this.scrolltoTop();
      this.helpSocial = !this.helpSocial;
      this.sectionEdit = this.helpSocial ? 'social' : null;
      this.editSocials = this.socials.map(s => Object.assign({}, s));
      this.disabledEdit = !this.disabledEdit;
    }
  }

  showInstruments() {
    if (this.edit) {
      this.scrolltoTop();
      this.helpInstruments = !this.helpInstruments;
      this.sectionEdit = this.helpInstruments ? 'instruments' : null;
      this.selectedInstruments = this.profileInstruments.values.map(s => Object.assign({}, s));
      this.disabledEdit = !this.disabledEdit;
    }
  }
//funcion generica para validar que componente se editara
  determinateFunction(value: any){
    if(value.component == 'chips_field'){
      if(value.model == 'instruments'){
        this.showInstruments();
      }
      if(value.model == 'genres' ){
        this.showGenre();
      }
    }
    
    if(value.component == 'text_field'){
      if(value.component.label == 'premios'){
        this.showRecognition();
      }

    }
  }

  
  showSkills() {
    if (this.edit) {
      this.scrolltoTop();
      this.helpSkills = !this.helpSkills;
      this.sectionEdit = this.helpSkills ? 'skills' : null;
      this.selectedSkills = this.profileSkills.map(s => Object.assign({}, s));
      this.disabledEdit = !this.disabledEdit;
    }
  }

  showGenre() {
    if (this.edit) {
      this.scrolltoTop();
      this.helpGenre = !this.helpGenre;
      this.sectionEdit = this.helpGenre ? 'genre' : null;
      this.selectedGenres = [...this.profileGenres.values];
      this.disabledEdit = !this.disabledEdit;
    }
  }
  //Funcion para mostrar los componentes de tipo profile
  showProfiles(profileType: string ){
    if(this.edit) {
      this.scrolltoTop();
      this.helpProfiles = !this.helpProfiles;
      this.helpProfilesEdit = false;
      this.sectionEdit = this.helpProfiles ? 'profiles' : null;
      this.profileProfiles.values.forEach(profile => {
        if(profile.fields[0].label == profileType){
          this.selectedProfile = [...profile.fields];
          this.selectedProfileString = JSON.parse(profile.fields[0].values);
        }
      });
    }
  }
  //Funcion para mostrar los componentes de tipo profile para la parte de edicion 
  showProfilesEdit( ){
    if(this.edit) {
      this.helpProfilesEdit = !this.helpProfilesEdit;
      this.helpProfiles = !this.helpProfiles;
      // this.disabledEdit = !this.disabledEdit;
    }
  }
  //Funcion para mostrar los componentes de tipo text  
  showEvents(eventsType: string){
    if (this.edit) {
      this.scrolltoTop();
      this.helpEvents = !this.helpEvents;
      this.sectionEdit = this.helpEvents ? 'events' : null;
      this.helpEventsEdit = false;
      this.profileEvents.values.forEach(events => {
        if(events.fields[0].label == eventsType){
          this.selectedEvents = [...events.fields];
          this.selectedEventsString = JSON.parse(events.fields[0].values);
        }
      });
    }
    }
    //Funcion para mostrar los componentes de tipo text para la parte de edicion 
    showEventsEdit( ){
      if(this.edit) {
        this.helpEventsEdit = !this.helpEventsEdit;
        this.helpEvents = !this.helpEvents;
        // this.disabledEdit = !this.disabledEdit;
      }
    }
//Funcion para mostrar los componentes de tipo checkbox
  showCheckBox(checkboxType: string ) {
    if (this.edit) {
      this.scrolltoTop();
      this.helpCheckBox = !this.helpCheckBox;
      this.sectionEdit = this.helpCheckBox ? 'checkbox' : null;
      this.profileCheckbox.values.forEach(checkbox => {
        if(checkbox.fields[0].group == checkboxType){
          this.selectedCheckBox = [...checkbox.fields];
          this.selectedCheckBoxOrigin = JSON.parse(JSON.stringify(checkbox.fields));
        }
      });
      this.disabledEdit = !this.disabledEdit;
    }
  }

  
  //funcion para ocultar los componentes de tipo profile
  showProfilesOff(){
    this.helpProfiles = !this.helpProfiles;
    this.helpProfilesEdit = false;
    this.disabledEdit = false;

  }
  //funcion para ocultar los componentes de tipo text
  showEventsOff(){
    this.helpEvents = !this.helpEvents;
    this.helpEventsEdit = false;
    this.disabledEdit = false;

  }

  //funcion para ocultar los componentes de tipo checkbox
  showCheckBoxOff(){
    this.helpCheckBox = !this.helpCheckBox;
    this.disabledEdit = !this.disabledEdit;

  }

  //funcion para determinarn cuando un valor cambio realmente para losc omponentes de tipo checkbox
  changeValueCheckBoxButtom(selectedObject: any){
    const index = this.selectedCheckBox.findIndex(obj => obj === selectedObject);
    //busca el boton y actualiza su valor
  if (index !== -1) {
    // Si se encontró el objeto, actualiza su valor
    this.selectedCheckBox[index].values = !this.selectedCheckBox[index].values; // Reemplaza 'nuevoValor' con el valor deseado
  }


  }

  scrolltoTop(): void {
    const top = this.elementRef.nativeElement.querySelector('#top');
    top.scrollIntoView({behavior: 'smooth'});
  }

  showRecognition() {
    if (this.edit) {
      this.scrolltoTop();
      this.helpRecognition = !this.helpRecognition;
      this.helpPrize = false;
      const comingFromPrize = this.sectionEdit === 'prize';
      if (!comingFromPrize) {
        this.selectedPrize = [...this.profilePrize.values];
        this.disabledEdit = !this.disabledEdit;
      }
      this.sectionEdit = this.helpRecognition ? 'recognition' : null;
    }
  }

  showPrize() {
    if (this.edit) {
      this.helpPrize = !this.helpPrize;
      this.helpRecognition = false;
      this.sectionEdit = this.helpPrize ? 'prize' : null;
    }
  }

  showEditAll() {
    if (this.edit) {
      this.helpEditAll = !this.helpEditAll;
      if(this.helpEditAll == false){
        this.updateProfileInfo();
      }
    }
  }

  addPrize() {
    if (this.prizeName && this.prizeCategory) {
      this.selectedPrize.push(this.prizeName + '$*$' + this.prizeCategory);
    }
    this.prizeName = '';
    this.prizeCategory = '';
    this.showRecognition();
  }

  removePrize(index) {
    this.selectedPrize.splice(index, 1);
  }
  //funcion que toma el arreglo de profiles que se esta trabajando y elima el elemento mediante el indice
  removeProfiles(index) {
    this.selectedProfileString.splice(index, 1);
  }

  //funcion que toma el arreglo de texts  que se esta trabajando y elima el elemento mediante el indice
  removeEvents(index) {
    this.selectedEventsString.splice(index, 1);
  }

  addInstrumentsRating() {
    this.selectedInstruments.push({instrument: this.nameInstruments, level: this.ratingInstruments});
    this.nameInstruments = null;
    this.ratingInstruments = 0;
  }

  removeInstrumentsRating(index) {
    this.selectedInstruments.splice(index, 1);
  }

  private updateSkills() {
    if (this.sectionEdit === 'skills') {
      this.selectedSkills.forEach(value => {
        const formData: any = new FormData();
        formData.append('user_field_id', value.user_field_id);
        formData.append('data', value.values ? 1 : 0);
        this.rest._post('profile/fields', formData).subscribe(() => this.getExtendedProfile());
      });
    }
  }

  private updateGenres() {
    if (this.sectionEdit === 'genre') {
      const formData: any = new FormData();
      formData.append('user_field_id', this.profileGenres.user_field_id);
      formData.append('data', JSON.stringify(this.selectedGenres));
      this.rest._post('profile/fields', formData).subscribe(() => this.getExtendedProfile());
    }
  }

  //metodo que actualiza cualquier checkbox
  private updatecheckbox() {
    if (this.sectionEdit === 'checkbox') {
      //obtenemos los checbox que cambiaron e iteramos sobre ellos
      const  differences: any = this.findDifferencesCheckBoxUpdate();
      differences.forEach(checkbox => {
        const formData: any = new FormData();
      formData.append('user_field_id', checkbox.user_field_id);
      let valorNumerico = checkbox.values ? 1 : 0;
      formData.append('data', JSON.stringify(valorNumerico));
      this.rest._post('profile/fields', formData).subscribe(() => this.getExtendedProfile());
        
      });
    }
  }

  //metodo que actualiza cualquier checkbox
  private updateProfilesEdit() {
    if (this.sectionEdit === 'profiles') {

        const formData: any = new FormData();
        formData.append('user_field_id', this.selectedProfile[0].user_field_id);
        formData.append('data', JSON.stringify(this.selectedProfileString));
      this.rest._post('profile/fields', formData).subscribe(() => this.getExtendedProfile());
    }
  }

  //metodo que actualiza cualquier evento textfield
  private updateEventsEdit() {
    if (this.sectionEdit === 'events') {

        const formData: any = new FormData();
        formData.append('user_field_id', this.selectedEvents[0].user_field_id);
        formData.append('data', JSON.stringify(this.selectedEventsString));
      this.rest._post('profile/fields', formData).subscribe(() => this.getExtendedProfile());
      this.showEventsOff();
    }
}
  //metodo que toma el usuario seleccionado y lo agrega al arregla de profiles para actualiza
  addProfileToarray(addProfile: any){
    const existe = this.selectedProfileString.some(profile => profile === addProfile);
    if (!existe) {
      this.selectedProfileString.push(addProfile);
    }
    this.showProfilesEdit();
  }

  //metodo que toma el evento y lo agrega al arreglo para mostrarlo y guardarlo
  addEventsToarray(addEvent: any){
    const existe = this.selectedProfileString.some(event => event === addEvent);
    if (!existe) {
      this.selectedEventsString.push(addEvent);
    }
    this.showEventsEdit();
  }

  //metodo que evalua si los vaores de los checkbox cambiaron para actualizarlos
  findDifferencesCheckBoxUpdate() {
    const differences = this.selectedCheckBox.filter(updated => {
      const existing = this.selectedCheckBoxOrigin.find(original => original.user_field_id === updated.user_field_id);
      return existing === undefined || existing.values !== updated.values;
    });

    return differences;
  }
  private updatePrize() {
    if (this.sectionEdit === 'recognition') {
      const formData: any = new FormData();
      formData.append('user_field_id', this.profilePrize.user_field_id);
      formData.append('data', JSON.stringify(this.selectedPrize));
      this.rest._post('profile/fields', formData).subscribe(() => this.getExtendedProfile());
    }
  }

  private updateSocial() {
    if (this.sectionEdit === 'social') {
      this.editSocials.forEach(value => {
        this.buildLinkToUser(value);
        const formData: any = new FormData();
        formData.append('user_field_id', value.user_field_id);
        formData.append('data', !value.values || value.values.trim() === '' ? '.' : value.values);
        this.rest._post('profile/fields', formData).subscribe(async () => {
          this.getExtendedProfile();
          this.showSocial();
          const toast = await this.toastController.create({
            message: 'Se ha guardado correctamente',
            duration: 3000,
            position: 'top',
            color: 'success',
            icon: 'checkmark-outline'
          });
          await toast.present();
          }, async error => {
          const toast = await this.toastController.create({
            message: 'No se puede guardar campos vacios en las redes sociales',
            duration: 3000,
            position: 'top',
            icon: 'warning-outline'
          });
          await toast.present();
        });
      });
    }
  }

  buildLinkToUser(value: any) {
    if(value.label === 'Instagram'){
      if(value.values.startsWith('@')){
        value.values = value.values.slice(1);
      } else if(value.values.includes('instagram.com')){
        const segments = value.values.split('/');
        const lastSegment = (segments[segments.length - 1] === '' || segments[segments.length - 1] !== segments[segments.length - 2]) ? segments[segments.length - 2] : segments[segments.length - 1];
        const firstAfterLastSegment = lastSegment.split('?' || '/')[0];
        value.values = value.values.replace(value.values, firstAfterLastSegment);
      }
    }
    if(value.label === 'TikTok'){
      if(value.values.startsWith('@')){
        value.values = value.values.slice(1);
      } else if(value.values.includes('tiktok.com')){
        const segments = value.values.split('@');
        const lastSegment = segments[segments.length - 1];
        const firstAfterLastSegment = lastSegment.split('?' || '/')[0];
        value.values = value.values.replace(value.values, firstAfterLastSegment);
      }
    }
    if(value.label === 'YouTube'){
      if(value.values.startsWith('@')){
        value.values = value.values.slice(1);
      } else if(value.values.includes('youtube.com')){
        const segments = value.values.split('@');
        const lastSegment = segments[segments.length - 1];
        const firstAfterLastSegment = lastSegment.split('?' || '/')[0];
        value.values = value.values.replace(value.values, firstAfterLastSegment);
      }
    }
    if(value.label === 'Twitter'){
      if(value.values.startsWith('@')){
        value.values = value.values.slice(1);
      } else if(value.values.includes('twitter.com')){
        const segments = value.values.split('/');
        const lastSegment = segments[segments.length - 1];
        const firstAfterLastSegment = lastSegment.split('?' || '/')[0];
        value.values = value.values.replace(value.values, firstAfterLastSegment);
      }
    }
    if(value.label === 'Facebook'){
      if(value.values.startsWith('@')){
        value.values = value.values.slice(1);
      } else if(value.values.includes('facebook.com')){
        const segments = value.values.split('/');
        const lastSegment = segments[segments.length - 1];
        const firstAfterLastSegment = lastSegment.split('?' || '/')[0];
        value.values = value.values.replace(value.values, firstAfterLastSegment);
      }
    }
  }

  showMobileSlide1() {
    this.isMobileSlide = false;
  }

  showMobileSlide2() {
    this.isMobileSlide = true;
  }

  presentPopover(e: Event) {
    this.popover.event = e;
    this.isOpen = true;
  }

  popoverPost(e: Event, item) {
    this.popoverEditPost.event = e;
    this.isOpenPost = true;
    this.dataPost = item;
  }

  popoverEditDisc(e: Event, item) {
    this.popoverEditDiscAlbum.event = e;
    this.isOpenEditDisc = true;
    this.dataEditDisc = item;
  }

  getPrizeName(prize: string): string {
    const strings = prize.split('$*$', 2);
    return strings.length > 0 ? strings[0] : '';
  }

  getPrizeCategory(prize: string): string {
    const strings = prize.split('$*$', 2);
    return strings.length > 1 ? strings[1] : '';
  }

  showName() {
    if (this.profile.name === '') {
      this.profile.name = 'Ingrese su nombre';
    }
    return this.profile.name;
  }

  private updateInstruments() {
    if (this.sectionEdit === 'instruments') {
      const formData: any = new FormData();
      formData.append('user_field_id', this.profileInstruments.user_field_id);
      formData.append('data', JSON.stringify(this.selectedInstruments));
      this.rest._post('profile/fields', formData).subscribe(() => this.getExtendedProfile());
    }
  }

  showModalAddPost() {
    const email = new RegExp("^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,5})$");
    if (this.util.token && this.util.user.msisdn === null
      || (this.util.token && this.util.user.msisdn !== null && (email.test(this.util.user.email) === true))) {
      this.sharedVarModalService.updateVarShowModal(true);
    } else if (this.util.token && this.util.user.msisdn !== null && (email.test(this.util.user.email) === false)) {
      this.showModalRegisterTelco();
    }
  }

  showModalRegisterTelco() {
    this.modalShowRegisterTelco = !this.modalShowRegisterTelco;
  }

  showModalAlertDelete() {
    this.modalShowAlertDelete = !this.modalShowAlertDelete;
    this.isOpenPost = false;
  }

  showModalAlertDeleteDisc() {
    this.modalShowAlertDeleteDisc = !this.modalShowAlertDeleteDisc;
    this.isOpenEditDisc = false;
  }

  gotoLogin() {
    this.navCtrl.navigateForward('/login');
    this.modalShowRegisterTelco = false;
  }

  gotoRegister() {
    this.navCtrl.navigateForward('/registro');
  }

  async deletePostServicesAndSearch() {
    const item = this.dataPost;
    switch (item.type) {
      case 'lesson':
        const dataLesson = {
          lesson_id: item.id
        };
        const auxLoading = await this.loadingCtrl.create({});
        await auxLoading.present();
        this.rest._post(('lessons/lessons/deactivate'), dataLesson).subscribe(async (resespone: any) => {
          this.getSliderProfile().subscribe(async () => {
            this.modalShowAlertDelete = false;
            await auxLoading.dismiss();
          }, (resr) => {
            console.log(resr);
          });
        }, async (error) => {
          await auxLoading.dismiss();
          console.error('error: ', error);
        });
        break;
      case 'sound-market':
        const dataService = {
          service_id: item.id
        };
        const auxLoading2 = await this.loadingCtrl.create({});
        await auxLoading2.present();
        this.rest._post(('services/services/deactivate'), dataService).subscribe(async (resespone: any) => {
          this.getSliderProfile().subscribe(async () => {
            this.modalShowAlertDelete = false;
            await auxLoading2.dismiss();
          }, (resr) => {
            console.log(resr);
          });
        }, async (error) => {
          await auxLoading2.dismiss();
          console.error('error: ', error);
        });
        break;
    }
    switch (item.subtype) {
      case 'LessonSearch':
        const dataSearchLesson = {
          search_id: item.id
        };
        const auxLoading3 = await this.loadingCtrl.create({});
        await auxLoading3.present();
        this.rest._post(('lessons/searches/deactivate'), dataSearchLesson).subscribe(async (resespone: any) => {
          this.getSearchSliderProfile().subscribe(async () => {
            this.modalShowAlertDelete = false;
            await auxLoading3.dismiss();
          }, (resr) => {
            console.log(resr);
          });
        }, async (error) => {
          await auxLoading3.dismiss();
          console.error('error: ', error);
        });
        break;
      case 'ServiceSearch':
        const dataSearchService = {
          search_id: item.id
        };
        const auxLoading4 = await this.loadingCtrl.create({});
        await auxLoading4.present();
        this.rest._post(('services/searches/deactivate'), dataSearchService).subscribe(async (resespone: any) => {
          this.getSearchSliderProfile().subscribe(async () => {
            this.modalShowAlertDelete = false;
            await auxLoading4.dismiss();
          }, (resr) => {
            console.log(resr);
          });
        }, async (error) => {
          await auxLoading4.dismiss();
          console.error('error: ', error);
        });
        break;
    }
  }

  editPostAndSearch() {
    this.rest.storageSet('idSearch', this.dataPost.id);
    this.rest.storageSet('front_option', this.dataPost.front_option);
    this.dismissClick();
    const item = this.dataPost;
    switch (item.type) {
      case 'lesson':
        this.navCtrl.navigateForward('/publicar/class/' + item.id);
        break;
      case 'sound-market':
        this.navCtrl.navigateForward('publicar/service/' + item.id); //TODO:Revisar porque cuando se cambia a espanol serivico no lo reconoce
        break;
      default:
        break;
    }
    switch (item.front_option) {
      case '1':
        this.goToNewServices();
        break;
      case '2':
        this.goToNewServices();
        break;
      case '3':
        this.goToNewServices();
        break;
      case '4':
        this.goToNewServices();
        break;
      default:
        break;
    }
  }

  async dismissClick() {
    await this.popoverController.dismiss();
  }

  addingSelectedOptionDiscInstrument(ev) {
    if (!this.optionSelectedDiscInstrument.includes(value => value === ev.detail.value)) {
      this.optionSelectedDiscInstrument = [...ev.detail.value];
      //this.selectedItemJob = [...this.optionSelectedDiscInstrument];
    }
  }

  addingSelectedOptionDiscArt(ev) {
    if (!this.optionSelectedDiscArt.includes(value => value === ev.detail.value)) {
      this.optionSelectedDiscArt = [...ev.detail.value];
      //this.selectedItemJob = [...this.optionSelectedDiscArt];
    }
  }

  addingSelectedOptionDiscRecording(ev) {
    const previousSize = this.optionSelectedDiscRecording.length;
    this.optionSelectedDiscRecording = [...ev.detail.value];
    if (this.optionSelectedDiscRecording.length === 0) {
      this.recordingList.forEach(value => {
        value.disabled = false;
      });
      this.popoverController.dismiss();
    }
    if (this.optionSelectedDiscRecording.length === 1) {
      const firstSelected = this.optionSelectedDiscRecording[0];
      const firstSelectedFound = this.recordingList.find(element => element.value === firstSelected);
      if (firstSelectedFound) {
        this.recordingList.forEach(value => {
          value.disabled = value.type !== firstSelectedFound.type;
        });
        if (previousSize === 0) {
          this.popoverController.dismiss();
        }
      }
    }
  }

  addingSelectedOptionDiscMastering(ev) {
    const previousSize = this.optionSelectedDiscMastering.length;
    this.optionSelectedDiscMastering = [...ev.detail.value];
    if (this.optionSelectedDiscMastering.length === 0) {
      this.masteringList.forEach(value => {
        value.disabled = false;
      });
      this.popoverController.dismiss();
    }
    if (this.optionSelectedDiscMastering.length === 1) {
      const firstSelected = this.optionSelectedDiscMastering[0];
      const firstSelectedFound = this.masteringList.find(element => element.value === firstSelected);
      if (firstSelectedFound) {
        this.masteringList.forEach(value => {
          value.disabled = value.type !== firstSelectedFound.type;
        });
        if (previousSize === 0) {
          this.popoverController.dismiss();
        }
      }
    }
  }

  deleteSelectedOptionDisc(item) {
    if (this.optionSelectedDiscInstrument.length > 0) {
      const index = this.selectedInstrumentDisc.indexOf(item);
      if (index > -1) {
        this.selectedInstrumentDisc.splice(index, 1);
        this.optionSelectedDiscInstrument = this.optionSelectedDiscInstrument.filter(filter => filter !== item);
      }
    }
    if (this.optionSelectedDiscArt.length > 0) {
      const index = this.selectedArtDisc.indexOf(item);
      if (index > -1) {
        this.selectedArtDisc.splice(index, 1);
        this.optionSelectedDiscArt = this.optionSelectedDiscArt.filter(filter => filter !== item);
      }
    }
    if (this.optionSelectedDiscRecording.length > 0) {
      const index = this.selectedRecordingDisc.indexOf(item);
      if (index > -1) {
        this.selectedRecordingDisc.splice(index, 1);
        this.optionSelectedDiscRecording = this.optionSelectedDiscRecording.filter(filter => filter !== item);
      }
    }

    if (this.optionSelectedDiscMastering.length > 0) {
      const index = this.selectedMasteringDisc.indexOf(item);
      if (index > -1) {
        this.selectedMasteringDisc.splice(index, 1);
        this.optionSelectedDiscMastering = this.optionSelectedDiscMastering.filter(filter => filter !== item);
      }
    }
  }

  deleteSelectedOptionDiscProducer() {
    this.optionSelectedDiscProducer = null;
    this.selectedItemJob = this.selectedItemJob.filter(filter => filter !== 'Productor');
  }

  /*isOptionDisabledDisc(item) {
    this.selectedRecordingDisc.includes(item);
  }*/

  showProducer() {
    this.producer = !this.producer;

    if (this.producer == false){
      this.optionSelectedDiscProducer = null;
    }
    if (this.optionSelectedDiscProducer !== 'Productor' && this.producer == true) {
      this.optionSelectedDiscProducer = 'Productor';
      //this.selectedItemJob = [...'Productor'];
    }

    // this.musician = false;
    // this.producer = false;
    // this.art = false;
    // this.recording = false;
    // this.mastering = false;
  }

  showMusician() {
    this.musician = !this.musician;

    if(!this.musician){
      this.optionSelectedDiscInstrument = [];
      this.selectedInstrumentDisc = []

    }
    // this.producer = false;
    // this.art = false;
    // this.recording = false;
    // this.mastering = false;
  }

  showArt() {
    this.art = !this.art;
    if(!this.art){
      this.selectedArtDisc = [];
      this.optionSelectedDiscArt = [];
    }
    // this.musician = false;
    // this.producer = false;
    // this.art = true;
    // this.recording = false;
    // this.mastering = false;
  }

  showRecording() {
    this.recording = !this.recording;
    if(!this.recording){
      this.selectedRecordingDisc = [];
      this.optionSelectedDiscRecording = [];
    }
    // this.musician = false;
    // this.producer = false;
    // this.art = false;
    // this.recording = true;
    // this.mastering = false;
  }

  showMastering() {
    // this.musician = false;
    // this.producer = false;
    // this.art = false;
    // this.recording = false;
    this.mastering = !this.mastering;
    if(!this.mastering){
      this.selectedMasteringDisc = [];
      this.optionSelectedDiscMastering = [];
    }
  }

  getDiscSpotify(search) {
    if (!search || search.trim() === '') {
      return of({
        body: {
          data: {
            discs: []
          }
        }
      });
    }

    const apiUrl = `discs/search?search=${search}`;
    return this.rest._get(apiUrl);
  }

  onSearchDiscSpotify(value) {
    this.searchDiscSpotify.next(value);
  }

  getArtistName(item: any): string {
    if(item.type === 'artist') {
      return item.name;

    } else {
      const artists: any[] = item.artists;
      // find first artist filtered by name
      const artist = artists.find((a) => a.name?.toLowerCase().includes(this.searchDiscSpotify.getValue()?.toLowerCase()));
      return artist ? artist.name : artists[0].name;
    }
  }

  getImgCover(item: any): string {
    if(item.type === 'track') {
      return item.album.images[0].url;

    } else {
      return item.images[0].url;
    }
  }

  getReleaseDate(item: any): string {
    if(item.type === 'track') {
      return item.album.release_date;

    } else {
      return item.release_date;
    }
  }

  getExternalUrl(item: any): string {
    if(item.type === 'track') {
      return item.album.external_urls.spotify;

    } else {
      return item.external_urls.spotify;
    }
  }

  getIdSpotify(item: any): string {
    if(item.type === 'track') {
      return item.album.id;

    } else {
      return item.id;
    }
  }

  selectItemDisc(item) {
    this.selectedDiscSpotifyImg = this.getImgCover(item);
    this.selectedDiscSpotifyArtist = this.getArtistName(item);
    this.selectedDiscSpotifyName = item.name;
    this.selectedDiscSpotifyReleaseDate = this.getReleaseDate(item);
    this.selectedDiscSpotifyExternalUrl = this.getExternalUrl(item);
    this.selectedIdSpotify = this.getIdSpotify(item);
    this.searchDiscSpotify.next('');
    this.showSelectedDiscSpotify = true;
  }

  clearSelectedDiscSpotify() {
    this.selectedDiscSpotifyImg = '';
    this.selectedDiscSpotifyArtist = '';
    this.selectedDiscSpotifyName = '';
    this.selectedDiscSpotifyReleaseDate = '';
    this.selectedDiscSpotifyExternalUrl = '';
    this.selectedIdSpotify = '';
    this.showSelectedDiscSpotify = false;
  }

  clearAllDisc() {
    this.selectedDiscSpotifyImg = '';
    this.selectedDiscSpotifyArtist = '';
    this.selectedDiscSpotifyName = '';
    this.selectedDiscSpotifyReleaseDate = '';
    this.selectedDiscSpotifyExternalUrl = '';
    this.selectedIdSpotify = '';
    this.showSelectedDiscSpotify = false;
    this.selectedArtDisc = [];
    this.selectedRecordingDisc = [];
    this.selectedMasteringDisc = [];
    this.selectedInstrumentDisc = [];
    this.optionSelectedDiscProducer = null;
    this.optionSelectedDiscRecording= [];
    this.optionSelectedDiscMastering = [];
    this.optionSelectedDiscInstrument = [];
    this.optionSelectedDiscArt = [];
    this.showButtonEditDisc = false;
  }

  async showModalDisc() {
    this.showModalPublishDisc = !this.showModalPublishDisc;
    await this.closeShowAlbum();
    await this.getProfileInfo();
    this.navCtrl.navigateForward('/mi-perfil');
  }

  public postAddDisc() {
    this.selectedItemJob = [this.selectedArtDisc, this.selectedRecordingDisc, this.selectedMasteringDisc, this.selectedInstrumentDisc, this.optionSelectedDiscProducer];
    const data = {
      name: this.selectedDiscSpotifyName,
      release_date: this.selectedDiscSpotifyReleaseDate,
      external_url: this.selectedDiscSpotifyExternalUrl,
      cover: this.selectedDiscSpotifyImg,
      player_info: this.selectedIdSpotify,
      job: this.selectedItemJob,
    };

    this.rest._post('discs', data).subscribe((resespone: any) => {
      this.showModalDisc();
      this.clearAllDisc();
    }, (error) => {
      console.error('error: ', error);
    });
  }

  public postEditDisc() {
    const item = this.dataEditDisc;
    this.selectedItemJob = [this.selectedArtDisc, this.selectedRecordingDisc, this.selectedMasteringDisc, this.selectedInstrumentDisc, this.optionSelectedDiscProducer];
    const data = {
      name: this.selectedDiscSpotifyName,
      release_date: this.selectedDiscSpotifyReleaseDate,
      external_url: this.selectedDiscSpotifyExternalUrl,
      cover: this.selectedDiscSpotifyImg,
      player_info: this.selectedIdSpotify,
      job: this.selectedItemJob,
    };

    this.rest._put(`discs/${item.id}`, data).subscribe((resespone: any) => {
      this.showModalDisc();
      this.clearAllDisc();
    }, (error) => {
      console.error('error: ', error);
    });
  }

  async deleteDiscSpotify() {
    const item = this.dataEditDisc;
    const auxLoading = await this.loadingCtrl.create({});
    await auxLoading.present();
    this.rest._delete(`discs/${item.id}`).subscribe(async (resespone: any) => {
        await this.getProfileInfo();
        this.modalShowAlertDeleteDisc = false;
        await auxLoading.dismiss();
    }, async (error) => {
      await auxLoading.dismiss();
      console.error('error: ', error);
    });
  }

  editDiscSpotify() {
    this.dismissClick();
    this.showButtonEditDisc = true;
    const item = this.dataEditDisc;
    this.selectedDiscSpotifyImg = item.cover;
    this.selectedDiscSpotifyArtist = item.name;
    this.selectedDiscSpotifyName = item.name;
    this.selectedDiscSpotifyReleaseDate = item.release_date;
    this.selectedDiscSpotifyExternalUrl = item.external_url;
    this.selectedIdSpotify = item.player_info;
    const discs: any[] = item.user_disc;
    const userDisc = discs.find(disc => disc.app_user_id === this.user.user_id);
    if (userDisc) {
      const job: any[] = JSON.parse(userDisc.job);
      if (job.some(value => value instanceof Array)) {
        this.selectedArtDisc = job[0];
        this.selectedRecordingDisc = job[1];
        this.selectedMasteringDisc =  job[2];
        this.selectedInstrumentDisc = job[3];
        this.optionSelectedDiscProducer = job[4];
        this.optionSelectedDiscArt = job[0];
        this.optionSelectedDiscRecording = job[1];
        this.optionSelectedDiscMastering = job[2];
        this.optionSelectedDiscInstrument = job[3];
      } else {
        job.forEach(jobItem => {
          if (jobItem.startsWith('Arte:')) {
            this.optionSelectedDiscArt = jobItem.replace('Arte:', '').trim().split(',');
          }
          if (jobItem.startsWith('Productor:')) {
            this.optionSelectedDiscProducer = jobItem.replace('Productor:', '').trim();
          }
          if (jobItem.startsWith('Grabación:')) {
            this.optionSelectedDiscRecording = jobItem.replace('Grabación:', '').trim().split(',');
          }
          if (jobItem.startsWith('Mezcla:')) {
            this.optionSelectedDiscMastering = jobItem.replace('Mezcla:', '').trim().split(',');
          }
          if (jobItem.startsWith('Músico:')) {
            this.optionSelectedDiscInstrument = jobItem.replace('Músico:', '').trim().split(',');
          }
        });
      }
    }
    this.showSelectedDiscSpotify = true;
    this.showDiscEditAlbums();
    //this.showModalPublishDisc = true;
    /*this.rest._put(`discs/${item.id}`, item).subscribe((resespone: any) => {
      console.log(resespone.body);
    }, (error) => {
      console.error('error: ', error);
    });*/
  }

   shareProfileDesktop(){
    const url = 'https://v2.louderband.com/perfiles/' + this.user.user_id;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(async () => {
        const toast = await this.toastCtrl.create({
          message: 'La URL se ha copiado al portapapeles.',
          duration: 2000,
          position: 'top'
        });
        await toast.present();
      }).catch((async ()=> {
        const toast = await this.toastCtrl.create({
          message: 'No se pudo copiar la URL al portapapeles.',
          duration: 2000,
          position: 'top'
        });
        await toast.present();
      }));
    };
  }

  shareDevice(index: number) {
    const element = document.querySelector('share-menu') as ShareMenu;
    element.targets[index].share(element);
  }

  metaDatos(){
    this.seoService.customizeMetaPageInfo({
      title: `Louderband | ${this.profile?.name}`,
      description: this.profile?.bio?.substr(0, 147) + '...',
      url: `https://v2.louderband.com/perfiles/${this.user.user_id}`,
      image: (this.util && this.util.user && this.util.user.profile_image) ? (this.isMacOS ? (this.profile.profile_image).replace('webp', 'jpg') : this.profile.profile_image) : 'https://www.louderband.com/assets/imagen/Profile.svg',
      slug: '',
    });
  }
}
